import { I18n } from "@/i18n";
import { css, cx } from "@styled-system/css";
import { Box, Container, Flex } from "@styled-system/jsx";
import { button } from "@styled-system/recipes";
import Animation from "@/assets/bibino/light-sleeping.json";
import Lottie from "@/components/react/Lottie";
import PageContainer from "@/components/react/PageContainer";
import Spinner from "@/components/react/Spinner";
import OpenOnMobile from "./OpenOnMobile";

type Props = {
  link?: string | null;
  state?: "loading" | "success" | "error" | "expired";
  strings: {
    title: {
      success?: string;
      expired?: string;
    };
    subtitle: {
      success?: string;
      expired?: string;
    };
    button: string;
    afterButton?: string;
  };
};

const getTitle = (strings: Props["strings"]["title"], state: Props["state"]) => {
  if (state === "error") return I18n.t("account.genericError");
  if (state === "loading" || "success") return strings.success;
  if (state === "expired") return strings.expired;
};

const getSubtitle = (strings: Props["strings"]["title"], state: Props["state"]) => {
  if (state === "error") return undefined;
  if (state === "loading" || "success") return strings.success;
  if (state === "expired") return strings.expired;
};

export default function Invite({ link, state, strings }: Props) {
  const isLoading = state === "loading";
  const isError = state === "error";
  const isExpired = state === "expired";

  const title = getTitle(strings.title, state);
  const subtitle = getSubtitle(strings.subtitle, state);

  return (
    <>
      <Box _mobile={{ display: "none" }}>
        <OpenOnMobile />
      </Box>
      <Container flexDir="column" alignItems="center" display="none" _mobile={{ display: "flex" }}>
        <Flex h="266px">
          <Lottie Animation={Animation} />
        </Flex>
        <PageContainer
          className={css({
            "& h2": { color: isError ? "warning" : "inherit" }
          })}
          title={title}
          subtitle={subtitle}
        >
          {isLoading && <Spinner size="40" />}
          {!isError && !isLoading && !isExpired && (
            <>
              <button
                className={cx(button({ variant: "filled" }), css({ mb: "7rem" }))}
                onClick={async () => {
                  if (!link) return;
                  await navigator.clipboard.writeText(link);
                  window.location.href = link;
                }}
              >
                {strings.button}
              </button>
              {strings.afterButton && (
                <p className={css({ textAlign: "center", mb: "2.6rem", fontStyle: "italic" })}>{strings.afterButton}</p>
              )}
            </>
          )}
        </PageContainer>
      </Container>
    </>
  );
}
